/**
 * 📱 Which build this is (M3, mobile gameplan). The web build and the app
 * bundles come from one codebase; scripts/build-mobile.mjs runs
 * `nuxt generate` with ED_NATIVE_PLATFORM set, and nuxt.config.ts turns
 * that into compile-time constants (vite.define), so the web build
 * compiles the defaults below and drops the native branches.
 *
 * Read with `typeof`, so code bundled without the defines (the esbuild unit
 * suites) sees the web defaults instead of a ReferenceError.
 */
declare const __ED_PLATFORM__: string | undefined
declare const __ED_APPCHECK_DEBUG_TOKEN__: string | undefined
declare const __ED_FIREBASE_APP_ID__: string | undefined

export type Platform = 'web' | 'android' | 'ios'

const built = typeof __ED_PLATFORM__ === 'string' ? __ED_PLATFORM__ : 'web'

export const PLATFORM: Platform = built === 'android' || built === 'ios' ? built : 'web'

/** A Capacitor app bundle (Android or iOS), not the website. */
export const IS_NATIVE = PLATFORM !== 'web'

/** A DEBUG app bundle's App Check debug token - registered in the Firebase
 * console, read by build-mobile from ed-secrets, never present in a web or
 * release build. Its presence selects the native debug provider; register
 * the per-install native secret from logcat before testing on a phone. */
export const APPCHECK_DEBUG_TOKEN = IS_NATIVE && typeof __ED_APPCHECK_DEBUG_TOKEN__ === 'string'
  ? __ED_APPCHECK_DEBUG_TOKEN__
  : ''

/** The app bundle's own Firebase app id ('1:...:android:...', from the
 * google-services.json the build carries), so its App Check tokens - and
 * the server's per-app log line - name the Android app, not the website.
 * Empty on the web. */
export const NATIVE_FIREBASE_APP_ID = IS_NATIVE && typeof __ED_FIREBASE_APP_ID__ === 'string'
  ? __ED_FIREBASE_APP_ID__
  : ''
